module.exports = __webpack_public_path__ + "img/广州恒泰科技创新产业园.d3b38c26.png";